import { useEffect, useState, useCallback } from "react";
import { ShieldCheck } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const STATUSES = ["Requested", "Received", "Reviewed", "Accepted", "Needs Replacement", "Not Applicable", "Pending", "Complete"];
const badge = (s) => ({ Pending: "bg-amber-100 text-amber-700", Requested: "bg-amber-100 text-amber-700", Received: "bg-blue-100 text-blue-700", Reviewed: "bg-indigo-100 text-indigo-700", Accepted: "bg-emerald-100 text-emerald-700", Complete: "bg-emerald-100 text-emerald-700", "Needs Replacement": "bg-red-100 text-red-700" }[s] || "bg-slate-100 text-slate-600");

export default function ComplianceManager() {
  const { can } = useAuth();
  const [items, setItems] = useState([]);
  const load = useCallback(() => { api.get("/admin/compliance/queue").then((r) => setItems(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);
  const setStatus = async (id, status) => { await api.put(`/admin/compliance/${id}`, { status }); load(); };

  return (
    <div data-testid="compliance-manager">
      <div className="mb-6 flex items-center gap-2"><ShieldCheck className="text-gold" size={24} /><div><h1 className="font-serif text-3xl font-bold text-navy">Compliance Oversight</h1><p className="mt-1 text-sm text-slate-500">{items.length} required check(s) awaiting completion across all matters.</p></div></div>
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-slate-200 bg-slate-50 text-xs uppercase tracking-wide text-slate-500"><tr><th className="px-5 py-3">Check</th><th className="px-5 py-3 hidden sm:table-cell">Category</th><th className="px-5 py-3">Matter</th><th className="px-5 py-3">Status</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {items.map((it) => (
              <tr key={it.id} data-testid={`compliance-row-${it.id}`} className="hover:bg-slate-50">
                <td className="px-5 py-3 font-medium text-navy">{it.item}</td>
                <td className="px-5 py-3 hidden sm:table-cell text-slate-500">{it.category}</td>
                <td className="px-5 py-3 text-slate-600">{it.matter_ref}<div className="text-xs text-slate-400">{it.client_name}</div></td>
                <td className="px-5 py-3"><select value={it.status} onChange={(e) => setStatus(it.id, e.target.value)} disabled={!can("compliance", "edit")} data-testid={`compliance-status-${it.id}`} className={`rounded-full px-2.5 py-1 text-xs font-medium ${badge(it.status)}`}>{STATUSES.map((s) => <option key={s}>{s}</option>)}</select></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={4} className="px-5 py-10 text-center text-slate-400">No outstanding compliance checks. Everything is up to date.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
